export const ADHD_ASSESSMENT_QUESTIONS = 'Click - Adhd Assessment Questions';
export const ADHD_ASSESSMENT_RESULT_GET_STARTED_BUTTON =
  'Click - Adhd Assessment Result Get Started Button';
export const ADHD_ASSESSMENT_RESULT_CREATE_ACCOUNT_BUTTON =
  'Click - Adhd Assessment Result Create Account Button';
export const ADHD_ASSESSMENT_MAILING_LIST_BUTTON =
  'Click - Adhd Assessment Mailing List Button';

export const ANXIETY_ASSESSMENT_QUESTIONS =
  'Click - Anxiety Assessment Questions';
export const ANXIETY_ASSESSMENT_MAILING_LIST_BUTTON =
  'Click - Anxiety Assessment Mailing List Button';
export const SCREENER_SELF_TEST = 'Screener Self Test';
export const ANXIETY_ASSESSMENT_RESULT_CONTINUE_BUTTON =
  'Click - Anxiety Assessment Result Continue Button';
export const ANXIETY_ASSESSMENT_RESULT_GET_STARTED_BUTTON =
  'Click - Anxiety Assessment Result Get Started Button';
export const ANXIETY_ASSESSMENT_RESULT_CREATE_ACCOUNT_BUTTON =
  'Click - Anxiety Assessment Result Create Account Button';
